import React, { useState } from "react";

import Nav from "react-bootstrap/Nav";

import NavigationLink from "./navigationLink";
import useNavigationData from "./useNavigationData";
import BrowserDetection from "../../utils/browserDetection";

const PrimaryNavigation = () => {
  const [hovered, setHovered] = useState({});

  const data = useNavigationData();

  const onMouseOver = (key, entered) => {
    const tmpHovered = {};

    Object.keys(hovered).forEach((key2) => {
      tmpHovered[key2] = false;
    });
    setHovered({ ...tmpHovered, [key]: entered });
  };

  const primaryNavigation = [];

  const isTouchScreen = BrowserDetection.hasTouchScreen();

  data.primaryNavigation?.elements.elements.value.forEach((item) => {
    primaryNavigation.push((
      <React.Fragment key={item.elements.title.value}>
        <Nav.Item
          onMouseEnter={() => {
            if (!isTouchScreen) {
              onMouseOver(item.elements.title.value, true);
            }
          }}
          onMouseLeave={() => onMouseOver(item.elements.title.value, false)}
        >
          <NavigationLink
            {...item}
            key={item.id}
            className="nav-link"
            onClick={(/* event */) => {
              if (isTouchScreen && window.matchMedia("(min-width:768px)").matches === true) {
                // event.preventDefault();
                onMouseOver(item.elements.title.value, !hovered[item.elements.title.value]);
              } else {
                onMouseOver(item.elements.title.value, false);
              }
            }}
          />
        </Nav.Item>
      </React.Fragment>
    ));
  });

  return React.Children.toArray(primaryNavigation);
};

export default PrimaryNavigation;
